/* Instruments */
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../../helper/url_helper";
import { get, post, put } from "../../../helper/api_helper";
import { gameSlice } from "./slice";
import { showToast } from "../../../helper/common";
import { authSlice } from "../auth/slice";
// import { socket } from "../../../utils/socket";
import { getValuesSocketData } from "../../../helper/secretManager";

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
let abortController;


export const getRoundMultiplier = createAsyncThunk(
  "getRoundMultiplier",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();
      const response = await post(URL.ROUND_MULTIPLIER, data, {
        signature,
        nonce,
      });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response);
      response.filter = data;
      return response;
    } catch (error) {
      console.error(error, "<===error");
      showToast(error?.message || "Something went wrong!", "error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  },
);


export const getSelectRoundMultiplier = createAsyncThunk(
  "getSelectRoundMultiplier",
  async ({ id, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await get(
        `${URL.SELECT_ROUNDMULTIPLIER_ROW}/${id}`,
        { signature, nonce }
      );

      callBack && callBack(null, response?.data);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);


export const removeSelectRoundMultiplier = createAsyncThunk(
  "RemoveSelectRoundMultiplier",
  async ({ id, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await get(
        `${URL.REMOVE_ROUNDMULTIPLIER_ROW}/${id}`,
        { signature, nonce }
      );

      callBack && callBack(null, response?.data);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
